import Asset from './Asset';
import AssetForm from './AssetForm';

const AssetConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/assets',
            element: <Asset />,
        },
        {
            path: '/addAsset',
            element: <AssetForm />,
        },
        {
            path: '/editAsset/:id',
            element: <AssetForm />,
        },
    ],
};

export default AssetConfig;
